import http from "@/http";

// ###  系统通知列表
//  http://base.leubao.com/api/notice/list
export const getNoticeList = {
  p: "/api/notice/list",
  r: data => {
    return http({
      url: "/api/notice/list",
      method: "post",
      data
    });
  }
};
//###  系统通知详情
//  http://base.leubao.com/api/notice/details/1
export const getNoticeInfo = {
  p: "/api/notice/details",
  r: data => {
    return http({
      url: "/api/notice/details/" + data.id,
      method: "get"
    });
  }
};
// ###  添加通知
//  http://base.leubao.com/api/notice/add
export const addNotice = {
  p: "/api/notice/add",
  r: data => {
    return http({
      url: "/api/notice/add",
      method: "post",
      data
    });
  }
};
//   ###  修改通知
//  http://base.leubao.com/api/notice/edit
export const editNotice = {
  p: "/api/notice/edit",
  r: data => {
    return http({
      url: "/api/notice/edit",
      method: "post",
      data
    });
  }
};
//###  删除通知
//  http://base.leubao.com/api/notice/delete
export const deleteNotice = {
  p: "/api/notice/delete",
  r: data => {
    return http({
      url: "/api/notice/delete",
      method: "post",
      data
    });
  }
};
